export const IconType = {
    MaterialUIIcon: 0,
    Url: 1,
    Image: 2
} as const;

export type IconType = typeof IconType[keyof typeof IconType];

export interface IProduct{
    overrideProductId?: string | null;
    name?: string;
    description?: string;
    clientId?: string | null;
    clickToDial?: string;
    isPanic?: boolean | null;
    isActive?: boolean | null;
    policyWording?: string;
    icon: string;
    iconType: IconType | null;
    clickToDialIsLink?: boolean | null;
}